import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type { SapAsyncPetitionDataQuery, SapAsyncPetitionDataQueryVariables } from './api.graphql';
import { SAPAsyncPetitionData } from './api.graphql';

type Petition = NonNullable<SapAsyncPetitionDataQuery['petition']>;
type FreePromotion = NonNullable<Petition['freePromotions']>[number];

type GetAsyncPetitionDataParams = {
	petitionId: string;
	fetchStarterFreePromotion: boolean;
};

export async function getAsyncPetitionData(
	{ petitionId, fetchStarterFreePromotion }: GetAsyncPetitionDataParams,
	{ gql: { fetch } }: UtilityContext,
): Promise<FreePromotion | undefined> {
	try {
		const { data } = await fetch<SapAsyncPetitionDataQuery, SapAsyncPetitionDataQueryVariables>({
			query: SAPAsyncPetitionData,
			variables: { slugOrId: petitionId, fetchStarterFreePromotion },
			rejectOnError: false,
		});

		if (!fetchStarterFreePromotion) return undefined;

		const freePromotion = data?.petition?.freePromotions?.find(
			(promotion) => promotion.sourceLocation === 'auto_free_promotion',
		);

		return freePromotion ?? undefined;
	} catch {
		// do nothing, we don't care if this fails
		return undefined;
	}
}
